import {
  Swiper, Navigation, FreeMode,
} from 'swiper';

const swiperContainerClass = '.complex-image-slider__swiper';

function initSliderImage(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    grabCursor: true,
    centerInsufficientSlides: true,
    slidesOffsetAfter: 24,
    slidesOffsetBefore: 24,
    breakpoints: {
      992: {
        spaceBetween: 24,
        slidesOffsetAfter: 40,
        slidesOffsetBefore: 40,
      },
      1200: {
        spaceBetween: 24,
        slidesOffsetAfter: 56,
        slidesOffsetBefore: 56,
      },
    },
    modules: [Navigation, FreeMode],
    freeMode: {
      enabled: true,
    },
    // mousewheel: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      lockClass: 'complex-image-slider__navigation--lock',
    },
    on: {
      lock() {
        const wrap = this.el.querySelector('.swiper-wrapper');
        wrap.style.marginLeft = '-56px';
      },
      resize() {
        if (!this.isLocked) {
          const wrap = this.el.querySelector('.swiper-wrapper');
          wrap.style.marginLeft = '0';
        }
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/complex-image-slider', ($block) => {
      initSliderImage($block.find(swiperContainerClass)[0]);
    });
  } else {
    initSliderImage(swiperContainerClass);
  }
});
